/** this module has all functions of service worker */
import config from './config.js';
import * as utils from './utils.js';

const subscribeHost = config.subscribe._subscribeHost;
const subscribePublicKey = config.subscribe._subscribePublicKey;
const subscribeAuth = config.subscribe._subscribeAuth;

export function initializeServiceWorker() {
    if ('serviceWorker' in window.navigator) {
        window.navigator.serviceWorker.register('../service-worker.js', { scope: '/' })
            .then(() => console.log('PWA registered successfully'))
            .catch(err => console.error('PWA registration failed:', err));
        //navigator.serviceWorker.ready.then(utils.whenControlled);

    }
}

export async function userIsSubscribed() {
    try {
        const registration = await navigator.serviceWorker.ready;
        const existing = await registration.pushManager.getSubscription();
        return existing !== null;
    } catch (err) {
        console.error('userIsSubscribed error:', err);
        return false;
    }
}
export async function subscribeUserToPush() {
    try {
        //console.log('start the function');
        const registration = await navigator.serviceWorker.ready;
        const existing = await registration.pushManager.getSubscription();
        if (existing) return existing;

        const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: utils.urlBase64ToUint8Array(subscribePublicKey)
        });

        await fetch(`${subscribeHost}/subscribe`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `${config.subscribe._subscribeAuth}` },
            body: JSON.stringify(subscription)
        });

        console.log('User subscribed successfully');
        return subscription;

    } catch (err) {
        console.error('Subscription failed: ', err);
    }
}